export const PLACE = 'Admin Role Audit Log';
